import React from 'react';
import { cn } from 'utils/cn';

interface DownloadTicketButtonProps {
  link: string;
  children: React.ReactNode;
  className?: string;
}

const DownloadTicketButton: React.FC<DownloadTicketButtonProps> = ({
  link,
  children,
  className,
}) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      download
      className={cn('flex gap-1 items-center w-full', className)}
    >
      {children}
    </a>
  );
};

export default DownloadTicketButton;
